/**
 * External dependencies
 */

import classnames from "classnames";

/**
 * Internal dependencies
 */
import Icon from "components/icon";
import { Text } from "../text";

/**
 * Style dependencies
 */
import "./styles.scss";

const Gravatar = ({ size = 40, username, ...props }) => {
  const classes = classnames("gravatar", props.className);

  const initials = username?.substring(0, 2).toUpperCase() || "";

  const initialsMarkup = initials ? (
    <div>
      <Text variant={"heading"} tone="ghost">
        {initials}
      </Text>
    </div>
  ) : null;

  return (
    <div className={classes} style={{ height: size, width: size }}>
      {initialsMarkup || <Icon name="FaRegUser" />}
    </div>
  );
};

export default Gravatar;
